import { TPODataContext } from 'contexts/TPOContext';
import React, { useContext } from 'react';

const PlanOverviewContainer = () => {
    const { selectedPlanInfo, dimensionConfigData } = useContext(TPODataContext);
    if (selectedPlanInfo?.planId)
        return (
            <div className="flex items-baseline gap-3">
                <p className="font-xxs flex-shrink-0 text-fontGreyAlt">
                    <span>Plan Year: </span>
                    <span>{selectedPlanInfo?.planYear}</span>
                </p>
                <p className="font-xxs flex-shrink-0 text-fontGreyAlt">
                    <span>{dimensionConfigData?.dim1Attribute?.label}: </span>
                    <span>{selectedPlanInfo?.dim1Filter?.value?.join(', ')}</span>
                </p>
                <p className="font-xxs flex-shrink-0 text-fontGreyAlt">
                    <span>{dimensionConfigData?.dim2Attribute?.label}: </span>
                    <span>{selectedPlanInfo?.dim2Filter?.value?.join(', ')}</span>
                </p>
            </div>
        );

    return null;
};

export default PlanOverviewContainer;
